// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/mltraining/v1/ml_training.proto" (package "viam.app.mltraining.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { Status } from "../../../google/rpc/status";
/**
 * @generated from protobuf message viam.app.mltraining.v1.SubmitTrainingJobRequest
 */
export interface SubmitTrainingJobRequest {
    /**
     * @generated from protobuf field: string dataset_id = 7;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: string organization_id = 2;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string model_name = 3;
     */
    modelName: string;
    /**
     * @generated from protobuf field: string model_version = 4;
     */
    modelVersion: string;
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.ModelType model_type = 5;
     */
    modelType: ModelType;
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.ModelFramework model_framework = 8;
     */
    modelFramework: ModelFramework;
    /**
     * @generated from protobuf field: repeated string tags = 6;
     */
    tags: string[];
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.SubmitTrainingJobResponse
 */
export interface SubmitTrainingJobResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.SubmitCustomTrainingJobRequest
 */
export interface SubmitCustomTrainingJobRequest {
    /**
     * @generated from protobuf field: string dataset_id = 1;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: string registry_item_id = 2;
     */
    registryItemId: string;
    /**
     * @generated from protobuf field: string registry_item_version = 6;
     */
    registryItemVersion: string;
    /**
     * @generated from protobuf field: string organization_id = 3;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string model_name = 4;
     */
    modelName: string;
    /**
     * @generated from protobuf field: string model_version = 5;
     */
    modelVersion: string;
    /**
     * @generated from protobuf field: map<string, string> arguments = 7;
     */
    arguments: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: string container_version = 8;
     */
    containerVersion: string;
    /**
     * @generated from protobuf field: string container_id = 9;
     */
    containerId: string;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.SubmitCustomTrainingJobResponse
 */
export interface SubmitCustomTrainingJobResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.GetTrainingJobRequest
 */
export interface GetTrainingJobRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.GetTrainingJobResponse
 */
export interface GetTrainingJobResponse {
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.TrainingJobMetadata metadata = 1;
     */
    metadata?: TrainingJobMetadata;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.ListTrainingJobsRequest
 */
export interface ListTrainingJobsRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.TrainingStatus status = 2;
     */
    status: TrainingStatus;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.ListTrainingJobsResponse
 */
export interface ListTrainingJobsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.mltraining.v1.TrainingJobMetadata jobs = 1;
     */
    jobs: TrainingJobMetadata[];
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.TrainingJobMetadata
 */
export interface TrainingJobMetadata {
    /**
     * @generated from protobuf field: string id = 7;
     */
    id: string;
    /**
     * @generated from protobuf field: string dataset_id = 11;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: string organization_id = 12;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string model_name = 13;
     */
    modelName: string;
    /**
     * @generated from protobuf field: string model_version = 14;
     */
    modelVersion: string;
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.ModelType model_type = 15;
     */
    modelType: ModelType;
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.ModelFramework model_framework = 17;
     */
    modelFramework: ModelFramework;
    /**
     * @generated from protobuf field: bool is_custom_job = 18;
     */
    isCustomJob: boolean;
    /**
     * @generated from protobuf field: string registry_item_id = 19;
     */
    registryItemId: string;
    /**
     * @generated from protobuf field: string registry_item_version = 20;
     */
    registryItemVersion: string;
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.TrainingStatus status = 2;
     */
    status: TrainingStatus;
    /**
     * @generated from protobuf field: google.rpc.Status error_status = 8;
     */
    errorStatus?: Status;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 3;
     */
    createdOn?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_modified = 4;
     */
    lastModified?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp training_started = 9;
     */
    trainingStarted?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp training_ended = 10;
     */
    trainingEnded?: Timestamp;
    /**
     * @generated from protobuf field: string synced_model_id = 5;
     */
    syncedModelId: string;
    /**
     * @generated from protobuf field: repeated string tags = 16;
     */
    tags: string[];
    /**
     * @generated from protobuf field: map<string, string> arguments = 21;
     */
    arguments: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: string container_version = 22;
     */
    containerVersion: string;
    /**
     * @generated from protobuf field: string container_id = 23;
     */
    containerId: string;
    /**
     * Colon-delimited triplets of components or services from the registry used when
     * model_framework is MODEL_FRAMEWORK_REGISTRY. This ties the ML model file to the
     * associated component or service that consumes the files and should be deployed
     * along with the model.
     *
     * @generated from protobuf field: repeated string deployment_modular_resources = 24;
     */
    deploymentModularResources: string[];
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.CancelTrainingJobRequest
 */
export interface CancelTrainingJobRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.CancelTrainingJobResponse
 */
export interface CancelTrainingJobResponse {
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.DeleteCompletedTrainingJobRequest
 */
export interface DeleteCompletedTrainingJobRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.DeleteCompletedTrainingJobResponse
 */
export interface DeleteCompletedTrainingJobResponse {
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.TrainingJobLogEntry
 */
export interface TrainingJobLogEntry {
    /**
     * @generated from protobuf field: string level = 1;
     */
    level: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time = 2;
     */
    time?: Timestamp;
    /**
     * @generated from protobuf field: string message = 3;
     */
    message: string;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.GetTrainingJobLogsRequest
 */
export interface GetTrainingJobLogsRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: optional string page_token = 2;
     */
    pageToken?: string;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.GetTrainingJobLogsResponse
 */
export interface GetTrainingJobLogsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.mltraining.v1.TrainingJobLogEntry logs = 1;
     */
    logs: TrainingJobLogEntry[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.ListSupportedContainersRequest
 */
export interface ListSupportedContainersRequest {
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.ListSupportedContainersResponse
 */
export interface ListSupportedContainersResponse {
    /**
     * @generated from protobuf field: map<string, viam.app.mltraining.v1.Container> container_map = 1;
     */
    containerMap: {
        [key: string]: Container;
    }; // ex value:
    // container_map: {
    //   "tf:2.15": Container {
    //     key: "tf:2.15"
    //     uri: "us-docker.pkg.dev/vertex-ai/training/tf-gpu.2-15.py310:latest"
    //     framework: Tensorflow
    //     description: "Tensorflow 2.15"
    //     eol: { seconds: 1772630400, nanos: 0 } // 2026-03-03T00:00:00Z
    //     created_on: 2026-01-15T01:30:15.01Z
    //     organization_id: "xyz"
    //     visibility: VISIBILITY_PUBLIC
    //   }
    // }
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.ListContainersRequest
 */
export interface ListContainersRequest {
    /**
     * The associated Viam organization ID.
     *
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.ListContainersResponse
 */
export interface ListContainersResponse {
    /**
     * @generated from protobuf field: repeated viam.app.mltraining.v1.Container containers = 1;
     */
    containers: Container[];
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.GetContainerRequest
 */
export interface GetContainerRequest {
    /**
     * The ID of the container to retrieve.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.GetContainerResponse
 */
export interface GetContainerResponse {
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.Container container = 1;
     */
    container?: Container;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.RegisterCustomTrainingContainerRequest
 */
export interface RegisterCustomTrainingContainerRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * Docker Hub reference, official images normalize to docker.io/library/<image>:<tag>.
     *
     * @generated from protobuf field: string image_uri = 2;
     */
    imageUri: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string; // will serve as display name
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.RegisterCustomTrainingContainerResponse
 */
export interface RegisterCustomTrainingContainerResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.DeleteCustomTrainingContainerRequest
 */
export interface DeleteCustomTrainingContainerRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.DeleteCustomTrainingContainerResponse
 */
export interface DeleteCustomTrainingContainerResponse {
}
/**
 * @generated from protobuf message viam.app.mltraining.v1.Container
 */
export interface Container {
    /**
     * @generated from protobuf field: string key = 1;
     */
    key: string; // custom container keys are derived from the Docker URI (image:tag)
    /**
     * @generated from protobuf field: string uri = 2;
     */
    uri: string;
    /**
     * @generated from protobuf field: string framework = 3;
     */
    framework: string; // unset for custom containers
    /**
     * @generated from protobuf field: string description = 4;
     */
    description: string; // will serve as display name
    /**
     * @generated from protobuf field: google.protobuf.Timestamp eol = 5;
     */
    eol?: Timestamp; // unset for custom containers
    /**
     * @generated from protobuf field: string organization_id = 6;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 7;
     */
    createdOn?: Timestamp;
    /**
     * @generated from protobuf field: string id = 8;
     */
    id: string; // unique id of the container
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.Visibility visibility = 9;
     */
    visibility: Visibility; // public or private
}
/**
 * @generated from protobuf enum viam.app.mltraining.v1.ModelType
 */
export enum ModelType {
    /**
     * @generated from protobuf enum value: MODEL_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: MODEL_TYPE_SINGLE_LABEL_CLASSIFICATION = 1;
     */
    SINGLE_LABEL_CLASSIFICATION = 1,
    /**
     * @generated from protobuf enum value: MODEL_TYPE_MULTI_LABEL_CLASSIFICATION = 2;
     */
    MULTI_LABEL_CLASSIFICATION = 2,
    /**
     * @generated from protobuf enum value: MODEL_TYPE_OBJECT_DETECTION = 3;
     */
    OBJECT_DETECTION = 3
}
/**
 * @generated from protobuf enum viam.app.mltraining.v1.ModelFramework
 */
export enum ModelFramework {
    /**
     * @generated from protobuf enum value: MODEL_FRAMEWORK_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: MODEL_FRAMEWORK_TFLITE = 1;
     */
    TFLITE = 1,
    /**
     * @generated from protobuf enum value: MODEL_FRAMEWORK_TENSORFLOW = 2;
     */
    TENSORFLOW = 2,
    /**
     * @generated from protobuf enum value: MODEL_FRAMEWORK_PYTORCH = 3;
     */
    PYTORCH = 3,
    /**
     * @generated from protobuf enum value: MODEL_FRAMEWORK_ONNX = 4;
     */
    ONNX = 4,
    /**
     * Modular components or services in the registry, identified by
     * deployment_modular_resources.
     * This is a deploy target, not a managed-training backend.
     *
     * @generated from protobuf enum value: MODEL_FRAMEWORK_REGISTRY = 5;
     */
    REGISTRY = 5
}
/**
 * @generated from protobuf enum viam.app.mltraining.v1.TrainingStatus
 */
export enum TrainingStatus {
    /**
     * @generated from protobuf enum value: TRAINING_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TRAINING_STATUS_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: TRAINING_STATUS_IN_PROGRESS = 2;
     */
    IN_PROGRESS = 2,
    /**
     * @generated from protobuf enum value: TRAINING_STATUS_COMPLETED = 3;
     */
    COMPLETED = 3,
    /**
     * @generated from protobuf enum value: TRAINING_STATUS_FAILED = 4;
     */
    FAILED = 4,
    /**
     * @generated from protobuf enum value: TRAINING_STATUS_CANCELED = 5;
     */
    CANCELED = 5,
    /**
     * @generated from protobuf enum value: TRAINING_STATUS_CANCELING = 6;
     */
    CANCELING = 6
}
/**
 * @generated from protobuf enum viam.app.mltraining.v1.Visibility
 */
export enum Visibility {
    /**
     * @generated from protobuf enum value: VISIBILITY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: VISIBILITY_PRIVATE = 1;
     */
    PRIVATE = 1,
    /**
     * @generated from protobuf enum value: VISIBILITY_PUBLIC = 2;
     */
    PUBLIC = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class SubmitTrainingJobRequest$Type extends MessageType<SubmitTrainingJobRequest> {
    constructor() {
        super("viam.app.mltraining.v1.SubmitTrainingJobRequest", [
            { no: 7, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"dataset_id\" json:\"dataset_id\"" } },
            { no: 2, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"organization_id\" json:\"organization_id\"" } },
            { no: 3, name: "model_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"model_name\" json:\"model_name\"" } },
            { no: 4, name: "model_version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"model_version\" json:\"model_version\"" } },
            { no: 5, name: "model_type", kind: "enum", T: () => ["viam.app.mltraining.v1.ModelType", ModelType, "MODEL_TYPE_"], options: { "tagger.v1.tags": "bson:\"model_type\" json:\"model_type\"" } },
            { no: 8, name: "model_framework", kind: "enum", T: () => ["viam.app.mltraining.v1.ModelFramework", ModelFramework, "MODEL_FRAMEWORK_"], options: { "tagger.v1.tags": "bson:\"model_framework\" json:\"model_framework\"" } },
            { no: 6, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"tags\" json:\"tags\"" } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.SubmitTrainingJobRequest
 */
export const SubmitTrainingJobRequest = new SubmitTrainingJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmitTrainingJobResponse$Type extends MessageType<SubmitTrainingJobResponse> {
    constructor() {
        super("viam.app.mltraining.v1.SubmitTrainingJobResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.SubmitTrainingJobResponse
 */
export const SubmitTrainingJobResponse = new SubmitTrainingJobResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmitCustomTrainingJobRequest$Type extends MessageType<SubmitCustomTrainingJobRequest> {
    constructor() {
        super("viam.app.mltraining.v1.SubmitCustomTrainingJobRequest", [
            { no: 1, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"dataset_id\" json:\"dataset_id\"" } },
            { no: 2, name: "registry_item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"registry_item_id\" json:\"registry_item_id\"" } },
            { no: 6, name: "registry_item_version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"registry_item_version\" json:\"registry_item_version\"" } },
            { no: 3, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"organization_id\" json:\"organization_id\"" } },
            { no: 4, name: "model_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"model_name\" json:\"model_name\"" } },
            { no: 5, name: "model_version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"model_version\" json:\"model_version\"" } },
            { no: 7, name: "arguments", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 8, name: "container_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "container_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.SubmitCustomTrainingJobRequest
 */
export const SubmitCustomTrainingJobRequest = new SubmitCustomTrainingJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmitCustomTrainingJobResponse$Type extends MessageType<SubmitCustomTrainingJobResponse> {
    constructor() {
        super("viam.app.mltraining.v1.SubmitCustomTrainingJobResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.SubmitCustomTrainingJobResponse
 */
export const SubmitCustomTrainingJobResponse = new SubmitCustomTrainingJobResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTrainingJobRequest$Type extends MessageType<GetTrainingJobRequest> {
    constructor() {
        super("viam.app.mltraining.v1.GetTrainingJobRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.GetTrainingJobRequest
 */
export const GetTrainingJobRequest = new GetTrainingJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTrainingJobResponse$Type extends MessageType<GetTrainingJobResponse> {
    constructor() {
        super("viam.app.mltraining.v1.GetTrainingJobResponse", [
            { no: 1, name: "metadata", kind: "message", T: () => TrainingJobMetadata }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.GetTrainingJobResponse
 */
export const GetTrainingJobResponse = new GetTrainingJobResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListTrainingJobsRequest$Type extends MessageType<ListTrainingJobsRequest> {
    constructor() {
        super("viam.app.mltraining.v1.ListTrainingJobsRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "status", kind: "enum", T: () => ["viam.app.mltraining.v1.TrainingStatus", TrainingStatus, "TRAINING_STATUS_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.ListTrainingJobsRequest
 */
export const ListTrainingJobsRequest = new ListTrainingJobsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListTrainingJobsResponse$Type extends MessageType<ListTrainingJobsResponse> {
    constructor() {
        super("viam.app.mltraining.v1.ListTrainingJobsResponse", [
            { no: 1, name: "jobs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TrainingJobMetadata }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.ListTrainingJobsResponse
 */
export const ListTrainingJobsResponse = new ListTrainingJobsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TrainingJobMetadata$Type extends MessageType<TrainingJobMetadata> {
    constructor() {
        super("viam.app.mltraining.v1.TrainingJobMetadata", [
            { no: 7, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"_id\" json:\"id,omitempty\"" } },
            { no: 11, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"dataset_id\" json:\"dataset_id\"" } },
            { no: 12, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"organization_id\" json:\"organization_id\"" } },
            { no: 13, name: "model_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"model_name\" json:\"model_name\"" } },
            { no: 14, name: "model_version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"model_version\" json:\"model_version\"" } },
            { no: 15, name: "model_type", kind: "enum", T: () => ["viam.app.mltraining.v1.ModelType", ModelType, "MODEL_TYPE_"], options: { "tagger.v1.tags": "bson:\"model_type\" json:\"model_type\"" } },
            { no: 17, name: "model_framework", kind: "enum", T: () => ["viam.app.mltraining.v1.ModelFramework", ModelFramework, "MODEL_FRAMEWORK_"], options: { "tagger.v1.tags": "bson:\"model_framework\" json:\"model_framework\"" } },
            { no: 18, name: "is_custom_job", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "tagger.v1.tags": "bson:\"is_custom_job\" json:\"is_custom_job\"" } },
            { no: 19, name: "registry_item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"registry_item_id\" json:\"registry_item_id\"" } },
            { no: 20, name: "registry_item_version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"registry_item_version\" json:\"registry_item_version\"" } },
            { no: 2, name: "status", kind: "enum", T: () => ["viam.app.mltraining.v1.TrainingStatus", TrainingStatus, "TRAINING_STATUS_"], options: { "tagger.v1.tags": "bson:\"status\" json:\"status\"" } },
            { no: 8, name: "error_status", kind: "message", T: () => Status, options: { "tagger.v1.tags": "bson:\"error_status\" json:\"error_status\"" } },
            { no: 3, name: "created_on", kind: "message", T: () => Timestamp, options: { "tagger.v1.tags": "bson:\"created_on\" json:\"created_on\"" } },
            { no: 4, name: "last_modified", kind: "message", T: () => Timestamp, options: { "tagger.v1.tags": "bson:\"last_modified\" json:\"last_modified\"" } },
            { no: 9, name: "training_started", kind: "message", T: () => Timestamp, options: { "tagger.v1.tags": "bson:\"training_started\" json:\"training_started\"" } },
            { no: 10, name: "training_ended", kind: "message", T: () => Timestamp, options: { "tagger.v1.tags": "bson:\"training_ended\" json:\"training_ended\"" } },
            { no: 5, name: "synced_model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"synced_model_id\" json:\"synced_model_id\"" } },
            { no: 16, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"tags\" json:\"tags\"" } },
            { no: 21, name: "arguments", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "tagger.v1.tags": "bson:\"arguments\" json:\"arguments\"" } },
            { no: 22, name: "container_version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"container_version\" json:\"container_version\"" } },
            { no: 23, name: "container_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"container_id\" json:\"container_id\"" } },
            { no: 24, name: "deployment_modular_resources", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"deployment_modular_resources\" json:\"deployment_modular_resources\"" } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.TrainingJobMetadata
 */
export const TrainingJobMetadata = new TrainingJobMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelTrainingJobRequest$Type extends MessageType<CancelTrainingJobRequest> {
    constructor() {
        super("viam.app.mltraining.v1.CancelTrainingJobRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.CancelTrainingJobRequest
 */
export const CancelTrainingJobRequest = new CancelTrainingJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelTrainingJobResponse$Type extends MessageType<CancelTrainingJobResponse> {
    constructor() {
        super("viam.app.mltraining.v1.CancelTrainingJobResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.CancelTrainingJobResponse
 */
export const CancelTrainingJobResponse = new CancelTrainingJobResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCompletedTrainingJobRequest$Type extends MessageType<DeleteCompletedTrainingJobRequest> {
    constructor() {
        super("viam.app.mltraining.v1.DeleteCompletedTrainingJobRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.DeleteCompletedTrainingJobRequest
 */
export const DeleteCompletedTrainingJobRequest = new DeleteCompletedTrainingJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCompletedTrainingJobResponse$Type extends MessageType<DeleteCompletedTrainingJobResponse> {
    constructor() {
        super("viam.app.mltraining.v1.DeleteCompletedTrainingJobResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.DeleteCompletedTrainingJobResponse
 */
export const DeleteCompletedTrainingJobResponse = new DeleteCompletedTrainingJobResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TrainingJobLogEntry$Type extends MessageType<TrainingJobLogEntry> {
    constructor() {
        super("viam.app.mltraining.v1.TrainingJobLogEntry", [
            { no: 1, name: "level", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "time", kind: "message", T: () => Timestamp },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.TrainingJobLogEntry
 */
export const TrainingJobLogEntry = new TrainingJobLogEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTrainingJobLogsRequest$Type extends MessageType<GetTrainingJobLogsRequest> {
    constructor() {
        super("viam.app.mltraining.v1.GetTrainingJobLogsRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page_token", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.GetTrainingJobLogsRequest
 */
export const GetTrainingJobLogsRequest = new GetTrainingJobLogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTrainingJobLogsResponse$Type extends MessageType<GetTrainingJobLogsResponse> {
    constructor() {
        super("viam.app.mltraining.v1.GetTrainingJobLogsResponse", [
            { no: 1, name: "logs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TrainingJobLogEntry },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.GetTrainingJobLogsResponse
 */
export const GetTrainingJobLogsResponse = new GetTrainingJobLogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSupportedContainersRequest$Type extends MessageType<ListSupportedContainersRequest> {
    constructor() {
        super("viam.app.mltraining.v1.ListSupportedContainersRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.ListSupportedContainersRequest
 */
export const ListSupportedContainersRequest = new ListSupportedContainersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSupportedContainersResponse$Type extends MessageType<ListSupportedContainersResponse> {
    constructor() {
        super("viam.app.mltraining.v1.ListSupportedContainersResponse", [
            { no: 1, name: "container_map", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Container } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.ListSupportedContainersResponse
 */
export const ListSupportedContainersResponse = new ListSupportedContainersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListContainersRequest$Type extends MessageType<ListContainersRequest> {
    constructor() {
        super("viam.app.mltraining.v1.ListContainersRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.ListContainersRequest
 */
export const ListContainersRequest = new ListContainersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListContainersResponse$Type extends MessageType<ListContainersResponse> {
    constructor() {
        super("viam.app.mltraining.v1.ListContainersResponse", [
            { no: 1, name: "containers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Container }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.ListContainersResponse
 */
export const ListContainersResponse = new ListContainersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetContainerRequest$Type extends MessageType<GetContainerRequest> {
    constructor() {
        super("viam.app.mltraining.v1.GetContainerRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.GetContainerRequest
 */
export const GetContainerRequest = new GetContainerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetContainerResponse$Type extends MessageType<GetContainerResponse> {
    constructor() {
        super("viam.app.mltraining.v1.GetContainerResponse", [
            { no: 1, name: "container", kind: "message", T: () => Container }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.GetContainerResponse
 */
export const GetContainerResponse = new GetContainerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterCustomTrainingContainerRequest$Type extends MessageType<RegisterCustomTrainingContainerRequest> {
    constructor() {
        super("viam.app.mltraining.v1.RegisterCustomTrainingContainerRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "image_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.RegisterCustomTrainingContainerRequest
 */
export const RegisterCustomTrainingContainerRequest = new RegisterCustomTrainingContainerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterCustomTrainingContainerResponse$Type extends MessageType<RegisterCustomTrainingContainerResponse> {
    constructor() {
        super("viam.app.mltraining.v1.RegisterCustomTrainingContainerResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.RegisterCustomTrainingContainerResponse
 */
export const RegisterCustomTrainingContainerResponse = new RegisterCustomTrainingContainerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCustomTrainingContainerRequest$Type extends MessageType<DeleteCustomTrainingContainerRequest> {
    constructor() {
        super("viam.app.mltraining.v1.DeleteCustomTrainingContainerRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.DeleteCustomTrainingContainerRequest
 */
export const DeleteCustomTrainingContainerRequest = new DeleteCustomTrainingContainerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCustomTrainingContainerResponse$Type extends MessageType<DeleteCustomTrainingContainerResponse> {
    constructor() {
        super("viam.app.mltraining.v1.DeleteCustomTrainingContainerResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.DeleteCustomTrainingContainerResponse
 */
export const DeleteCustomTrainingContainerResponse = new DeleteCustomTrainingContainerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Container$Type extends MessageType<Container> {
    constructor() {
        super("viam.app.mltraining.v1.Container", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "framework", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "eol", kind: "message", T: () => Timestamp },
            { no: 6, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "created_on", kind: "message", T: () => Timestamp },
            { no: 8, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "visibility", kind: "enum", T: () => ["viam.app.mltraining.v1.Visibility", Visibility, "VISIBILITY_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.mltraining.v1.Container
 */
export const Container = new Container$Type();
/**
 * @generated ServiceType for protobuf service viam.app.mltraining.v1.MLTrainingService
 */
export const MLTrainingService = new ServiceType("viam.app.mltraining.v1.MLTrainingService", [
    { name: "SubmitTrainingJob", options: {}, I: SubmitTrainingJobRequest, O: SubmitTrainingJobResponse },
    { name: "SubmitCustomTrainingJob", options: {}, I: SubmitCustomTrainingJobRequest, O: SubmitCustomTrainingJobResponse },
    { name: "GetTrainingJob", options: {}, I: GetTrainingJobRequest, O: GetTrainingJobResponse },
    { name: "ListTrainingJobs", options: {}, I: ListTrainingJobsRequest, O: ListTrainingJobsResponse },
    { name: "CancelTrainingJob", options: {}, I: CancelTrainingJobRequest, O: CancelTrainingJobResponse },
    { name: "DeleteCompletedTrainingJob", options: {}, I: DeleteCompletedTrainingJobRequest, O: DeleteCompletedTrainingJobResponse },
    { name: "GetTrainingJobLogs", options: {}, I: GetTrainingJobLogsRequest, O: GetTrainingJobLogsResponse },
    { name: "ListSupportedContainers", options: {}, I: ListSupportedContainersRequest, O: ListSupportedContainersResponse },
    { name: "ListContainers", options: {}, I: ListContainersRequest, O: ListContainersResponse },
    { name: "GetContainer", options: {}, I: GetContainerRequest, O: GetContainerResponse },
    { name: "RegisterCustomTrainingContainer", options: {}, I: RegisterCustomTrainingContainerRequest, O: RegisterCustomTrainingContainerResponse },
    { name: "DeleteCustomTrainingContainer", options: {}, I: DeleteCustomTrainingContainerRequest, O: DeleteCustomTrainingContainerResponse }
]);
